import { Typography } from '@mui/material';
import { useState } from 'react';
import { LANGUAGES } from '../privacyPolicy.constants';
import { PrivacyPolicyComponentStyled } from './privacyPolicyComponent.styled';

const PrivacyPolicyComponent = () => {
  const [language, selectedLanguage] = useState('en');

  return (
    <PrivacyPolicyComponentStyled>
      <Typography variant="h3">Privacy Policy - Khata Book</Typography>
      <iframe
        key={language}
        src={LANGUAGES[language].url}
        className="iframe"
      ></iframe>
    </PrivacyPolicyComponentStyled>
  );
};

export default PrivacyPolicyComponent;
